import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { FC } from 'react';
import 'react-multi-carousel/lib/styles.css';
import Image from 'blog/components/Image';

export interface CardWithImageProps {
  image: string;
  title?: string;
  text: string;
  isLeftSideImage?: boolean;
  width: number;
  height: number;
  hasDivider?: boolean;
  orangeTitle?: boolean;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    title: {
      color: 'rgba(69, 55, 55, 1)',
      fontWeight: 700,
      fontSize: 54,
      [theme.breakpoints.down('sm')]: {
        fontSize: 48,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 32,
      },
    },
    orangeTitle: {
      color: theme.palette.primary.main,
      fontWeight: 700,
      fontSize: 54,
      [theme.breakpoints.down('sm')]: {
        fontSize: 48,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 32,
      },
    },
    text: {
      color: 'rgba(69, 55, 55, 1)',
      fontSize: 20,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
    centeredGrid: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        order: 1,
      },
      '& ul': {
        marginLeft: theme.spacing(-3),
        fontSize: 16,
        [theme.breakpoints.up('sm')]: {
          fontSize: 24,
        },
        '& li': {
          '& p': {
            fontSize: 16,
            fontWeight: 700,
            color: `#453737`,
            [theme.breakpoints.up('sm')]: {
              fontSize: 24,
            },
          },
        },
      },
    },
    imageBlock: {
      [theme.breakpoints.down('sm')]: {
        order: 2,
      },
    },
    divider: {
      width: 280,
      height: 4,
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(4, 0),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(4, 0, 2),
        width: 168,
      },
    },
  });
});

const CardWithImage: FC<CardWithImageProps> = (props) => {
  const classes = useStyles();
  const { title, text, hasDivider = false, orangeTitle = false, image, isLeftSideImage, width, height } = props;
  const isMedium = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Container data-aos="fade-up" data-aos-delay="400" fixed>
      <Box mt={isMedium ? 22 : 10} />
      <Grid container spacing={6}>
        {!isLeftSideImage ? (
          <Grid item sm={12} md={5} className={classes.centeredGrid}>
            <Typography variant="h1" className={orangeTitle ? classes.orangeTitle : classes.title}>
              {title}
            </Typography>
            <Box mb={4} />
            <Typography className={classes.text}>{text}</Typography>
            {hasDivider && <Box className={classes.divider} />}
          </Grid>
        ) : (
          <Grid className={classes.imageBlock} item sm={12} md={7}>
            <Box>
              <Image src={image} alt={title} width={width} height={height} />
            </Box>
          </Grid>
        )}

        {!isLeftSideImage ? (
          <Grid className={classes.imageBlock} item sm={12} md={7}>
            <Box>
              <Image src={image} alt={title} width={width} height={height} />
            </Box>
          </Grid>
        ) : (
          <Grid item sm={12} md={5} className={classes.centeredGrid}>
            <Typography variant="h1" className={orangeTitle ? classes.orangeTitle : classes.title}>
              {title}
            </Typography>
            <Box mb={4} />
            <Typography className={classes.text}>{text}</Typography>
            {hasDivider && <Box className={classes.divider} />}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default CardWithImage;
